import React, { Component, useState, useEffect } from "react";
import "./TotalCss.css";
import { Row, Col, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { SiteTitle } from "./SiteTitle";
import { FetchDataApply } from "./FetchDataApply";
import { FetchDataApplyNet } from "./FetchDataApplyNet";
import { SelectUnit } from "./BasicComponents/SelectUnit";
import { SelectUrl } from "./BasicComponents/SelectUrl";
import { SelectNet } from "./BasicComponents/SelectNet";
import { SelectName } from "./BasicComponents/SelectName";
import { SelectUnitproxyApply } from "./BasicComponents/SelectUnitproxyApply";
import { SelectUrlProxyApply } from "./BasicComponents/SelectUrlProxyApply";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { api_url } from "./globalFunction/global_string";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

export class SiteScanApply extends Component {
  static displayName = SiteScanApply.name;

  constructor(props) {
    super(props);
    this.state = {
      pendingInspectionCount: 0, // 待檢測數
      availableToApplyCount: 8, // 可申請數
      allusagecountToCount: 0, // 全部人的申請數
      waitingQueuePosition: 0,//等待順位
      showModal: false, //初始化 modal 關閉
      betaversion: '3', //版本
      showDetails: {
        '1': false,
        '2': false,
        '3': false,
      },
      isFetchDataApply: '',
      selectedName: '',
      firstLocalUnitName: '',
      firstLocalUnitValue: '',
      checked: false,
      currentMode: 'scan',
      pendingInspectionItems: '',
      requiresLoginScan: false, // 表示是否需要登錄掃描
      selectedFile: null,
      formData: {
        excel_unit_name: '',
        excel_unit_url: '',
        scan_apply_start: '',
        scan_apply_end: '',
      },
      fetchDataForTableApply: {
        parentName: "SiteApply",
        current_user_type: localStorage.getItem('login_user_type'),
        local_net_id: localStorage.getItem('login_user_net_id'),
        local_unit_id: localStorage.getItem('login_user_unit_id'),
        url_addr: '',
        fetchDataExcelApi: api_url + "/api/SCHE/GetSchedule",
      },
      fetchDataForTableProxyApply: {
        current_user_type: localStorage.getItem('login_user_type'),
        local_net_id: localStorage.getItem('login_user_net_id'),
        local_unit_id: localStorage.getItem('login_user_unit_id'),
        url_addr: '',
        fetchDataExcelApi: api_url + "/api/SCHE/GetScanProxyReference",
        updatedata: true
      },
      submitCount: 0,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleClearForm = this.handleClearForm.bind(this);
  }

  handleChange() {
    this.setState(prevState => ({
      checked: !prevState.checked,
      currentMode: !prevState.checked ? 'proxy' : 'scan'
    }), () => {
      this.handlePendingInspectionItemsChange(this.state.pendingInspectionItems);
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectnet !== this.state.selectnet) {
      this.handleClearForm();
    }
    if (prevState.currentMode !== this.state.currentMode) {
      this.handlePendingInspectionItemsChange(this.state.pendingInspectionItems);
    }
  }

  handlePendingInspectionItemsChange = (pendingInspectionItems) => {
    if (!Array.isArray(pendingInspectionItems)) {
      console.error('pendingInspectionItems is not an array:', pendingInspectionItems);
      return;
    }
    console.log(pendingInspectionItems)
    let pendingInspectionCount = 0;
    let availableToApplyCount = 0;

    if (this.state.currentMode === 'scan') {
      const countStatus0 = pendingInspectionItems.filter(item => item.scan_status === "0").length;
      const countStatus1 = pendingInspectionItems.filter(item => item.scan_status === "1").length;
      pendingInspectionCount = countStatus0 + countStatus1;
    } else if (this.state.currentMode === 'proxy') {
      const countStatus0 = pendingInspectionItems.filter(item => item.scan_status === "0").length;
      const countStatus1 = pendingInspectionItems.filter(item => item.scan_status === "1").length;
      pendingInspectionCount = countStatus0 + countStatus1;
    }

    availableToApplyCount = 8 - pendingInspectionCount;

    this.setState({ pendingInspectionCount, availableToApplyCount });
  };


  componentDidMount() {
    this.loadData();
    this.getUsageCount()
    this.getwaitingQueuePositionCount()
    this.setState({ isFetchDataApply: true });
  }

  toggleModal = () => {
    this.setState({
      showModal: !this.state.showModal
    })
  }

  handleClearForm() {
    this.setState({
      selectedUnitproxy: '',
      local_unit_proxy_name: '請選擇',
      selecteduser: '',
    });
  }


  loadData() {
    let apiUrl = api_url + "/api/JRCC/GetLocalUnitId";
    const formData = new FormData();
    formData.append("current_user_type", localStorage.getItem('login_user_type'));
    formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
    formData.append("local_unit_id", localStorage.getItem('login_user_unit_id'));

    fetch(apiUrl, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        if (data.row && Array.isArray(data.row) && data.row.length > 0) {
          this.setState({
            firstLocalUnitName: data.row[0].local_unit_name,
            firstLocalUnitValue: data.row[0].local_unit_id
          });
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  //取的目前全部申請數量
  getUsageCount() {
    let apiUrl = api_url + "/api/SCHE/Getusagecount";
    fetch(apiUrl, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
    })
      .then(response => response.json())
      .then(data => {
        // console.log(data)
        this.setState({ allusagecountToCount: data.row[0] });
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  //使用者最快取掃描數量
  getwaitingQueuePositionCount() {
    let apiUrl = api_url + "/api/SCHE/GetwaitingQueuePositionCount";
    const formData = new FormData();
    formData.append("user_id", localStorage.getItem('login_user_id'));

    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Authorization": localStorage.getItem('accessToken'),
      },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data.row)
        this.setState({ waitingQueuePosition: data.row });
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }
  //自己掃描模式申請按鈕
  handleSubmit = (event) => {
    let local_net_id = localStorage.getItem('login_user_net_id');
    let local_unit_id = localStorage.getItem('login_user_unit_id');
    let url_addr = this.state.formData.excel_unit_url;
    let version = this.state.betaversion;
    console.log(this.state.formData)
    const { Url_name } = this.state.formData;
    event.preventDefault();
    if (this.state.availableToApplyCount <= 0) {
      MySwal.fire('錯誤', '您已達到最大申請數量，不能再申請', 'error');
      return;
    }
    if (this.state.requiresLoginScan && !this.state.selectedFile) {
      MySwal.fire('錯誤', '請選擇一個檔案上傳', 'error');
      return;
    } else if (this.state.selectedFile && (!this.state.selectedFile.name.endsWith('.login') && !this.state.selectedFile.name.endsWith('.config'))) {
      MySwal.fire('錯誤', '請上傳一個.login或.config格式的檔案', 'error');
      return;
    }

    if (!url_addr || url_addr.trim() === '') {
      MySwal.fire('錯誤', '請選擇有效的網址', 'error');
      return;
    }

    MySwal.fire({
      title: '您確定要提交申請嗎？',
      text: "掃描一經提交後，無法再停止，請確保已經做好網站、資料庫與伺服器備份，並確定掃描網址與登入檔案的帳號與密碼是正確的。",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: '確定',
      cancelButtonText: '取消'
    }).then((result) => {
      const formData = new FormData();
      if (result.isConfirmed) {
        if (this.state.requiresLoginScan && this.state.selectedFile) {
          formData.append("fileUpload", this.state.selectedFile);
        }
        let apiUrl = api_url + "/api/SCHE/PostSchedule";
        formData.append("Local_unit_id", local_unit_id);
        formData.append("Local_net_id", local_net_id);
        formData.append("Url_id", url_addr);
        formData.append("Url_addr", Url_name);

        formData.append("betaversion", version)
        MySwal.fire({
          title: '處理中...',
          text: '請稍等',
          allowOutsideClick: false,
          showConfirmButton: false,
          onBeforeOpen: () => {
            MySwal.showLoading();
          }
        });

        fetch(apiUrl,
          {
            method: "POST",
            headers: {
              "Authorization": localStorage.getItem('accessToken'),
            },
            body: formData
          })
          .then(response => response.json())
          .then(data => {
            let arr_status = [String(data.statusCode), data.row, data.detail]; //api 回傳判斷
            //console.log(arr_status[0])
            if (arr_status[0] === "200") {
              this.setState((prevState) => ({
                fetchDataForTableApply: {
                  ...prevState.fetchDataForTableApply,
                  url_addr: this.state.formData.excel_unit_url,
                },
                isFetchDataApply: false,
                selectedFile: null,
              }), () => {
                this.setState({ isFetchDataApply: true });
                this.getUsageCount();
                this.getwaitingQueuePositionCount()
                this.handlePendingInspectionItemsChange();
              });
              MySwal.close();
              MySwal.fire({
                title: '申請成功',
                text: '排程設定成功',
                icon: 'success'
              });
            } else {
              MySwal.close();
              MySwal.fire({
                title: '請聯絡管理員',
                text: `${data.row}`,
                icon: 'error'
              });
              this.getUsageCount();
              this.getwaitingQueuePositionCount()
              this.handlePendingInspectionItemsChange();
            }
          })
          .catch(error => {
            MySwal.close();
            console.error('Error:', error);
            MySwal.fire({
              title: '請聯絡管理員',
              text: `錯誤`,
              icon: 'error'
            }); // 顯示一個通用的錯誤訊息
            this.getUsageCount();
            this.getwaitingQueuePositionCount()
            this.handlePendingInspectionItemsChange();
          });
      }
    })
  };


  //代理掃描模式申請按鈕
  handleProxySubmit = (event) => {
    const { Url_name, excel_unit_proxy_url, url_id, url_addr } = this.state.formData;

    console.log(this.state.formData)
    console.log(Url_name)
    console.log(excel_unit_proxy_url)
    console.log(url_id)
    console.log(url_addr)

    event.preventDefault();
    if (this.state.availableToApplyCount <= 0) {
      MySwal.fire('錯誤', '使用者已超過可申請數量，不能再申請', 'error');
      return;
    }
    if (this.state.requiresLoginScan && !this.state.selectedFile) {
      MySwal.fire('錯誤', '請選擇一個檔案上傳', 'error');
      return;
    }
    // 檢查必選的下拉選單是否都已選擇
    if (this.state.fetchDataForTableProxyApply.current_user_type === "S") {
      if (!this.state.selectedUnitproxy || !excel_unit_proxy_url || !this.state.selecteduser) {
        MySwal.fire('錯誤', '所有下拉選單都必須選擇', 'error');
        return;
      }
    } else if (this.state.fetchDataForTableProxyApply.current_user_type === "M") {
      if (!excel_unit_proxy_url || !this.state.selecteduser) {
        MySwal.fire('錯誤', '所有下拉選單都必須選擇', 'error');
        return;
      }
    }
    MySwal.fire({
      title: '您確定要提交申請嗎？',
      text: "掃描一經提交後，無法再停止，請確保已經做好網站、資料庫與伺服器備份，並確定掃描網址與登入檔案的帳號與密碼是正確的。",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: '確定',
      cancelButtonText: '取消'
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        if (this.state.requiresLoginScan && this.state.selectedFile) {
          formData.append("fileUpload", this.state.selectedFile);
        }
        let apiUrl = api_url + "/api/SCHE/PostProxyScheduleReference";
        formData.append("Local_unit_id", this.state.selectedUnitproxy);
        if (this.state.fetchDataForTableProxyApply.current_user_type === "M") {
          formData.append("Local_net_id", this.state.fetchDataForTableProxyApply.local_net_id);
        } else {
          formData.append("Local_net_id", this.state.selectnet);
        }
        formData.append("Url_id", excel_unit_proxy_url);
        formData.append("Url_addr", Url_name);
        formData.append("user_name", this.state.selecteduser);
        formData.append("betaversion", this.state.betaversion)
        formData.append("user_id", localStorage.getItem('login_user_id'))

        MySwal.fire({
          title: '處理中...',
          text: '請稍等',
          allowOutsideClick: false,
          showConfirmButton: false,
          onBeforeOpen: () => {
            MySwal.showLoading();
          }
        });
        fetch(apiUrl,
          {
            method: "POST",
            headers: {
              "Authorization": localStorage.getItem('accessToken'),
            },
            body: formData
          })
          .then(response => response.json())
          .then(data => {
            let arr_status = [String(data.statusCode), data.row, data.detail]; //api 回傳判斷
            console.log(arr_status[0])
            if (arr_status[0] === "200") {
              this.setState({
                fetchDataForTableProxyApply: {
                  ...this.state.fetchDataForTableProxyApply,
                  updatedata: false
                },
                isFetchDataApply: false,
                selectedFile: null,
                submitCount: 1
              }, () => {
                this.handlePendingInspectionItemsChange();
                this.setState({ isFetchDataApply: true });
                this.getUsageCount();
                this.getwaitingQueuePositionCount();
              });


              MySwal.close();
              MySwal.fire({
                title: '申請成功',
                text: '排程設定成功',
                icon: 'success'
              });
            } else {
              MySwal.close();
              MySwal.fire({
                title: '請聯絡管理員',
                text: `${data.row}`,
                icon: 'error'
              });
            }
          })
          .catch(error => {
            MySwal.close();
            console.error('Error:', error);
            MySwal.fire('錯誤', '下拉選單一定要有資料', 'error');
          });
      }
    })
  };

  resetSubmitCount = () => {
    this.setState({ submitCount: 0 });
  }
  //版本選擇的複選框
  handleVersionChange = (version) => {
    this.setState({ betaversion: version });
  };
  toggleDetails = (version) => {
    this.setState(prevState => ({
      showDetails: {
        ...prevState.showDetails,
        [version]: !prevState.showDetails[version]
      }
    }));
  };

  renderTestDetails = () => {
    const versionDetails = {
      '1': {
        title: '開發版',
        description: '無安裝HTTP伺服器，需透過特殊PORT連線。',
        example: 'http://111.111.111.111:8000/',
        testItems: ['Abuse of Functionality', 'Broken Object Level on API', 'Buffer Overflow', 'Cross-site Scripting', 'Directory Indexing', 'Format String', 'HTTP Response Splitting', 'Information Leakage'
          , 'Insecure Indexing', 'Insufficient Authentication', 'Insufficient Authorization', 'Insufficient Session Expiration', 'Integer Overflows', 'Null Byte injection', 'OS Commanding', 'Path Traversal'
          , 'Predictable Resource Location', 'Remote File Inclusion', 'Session Fixation', 'SQL Injection', 'URL Redirector Abuse'],
      },
      '2': {
        title: '測試版',
        description: '安裝HTTP伺服器，但尚無網域、使用自簽憑證',
        example: 'https://111.111.111.111',
        testItems: ['Abuse of Functionality', 'Broken Object Level on API', 'Buffer Overflow', 'Credential/Session Prediction', 'Cross-site Scripting', 'Directory Indexing', 'Format String'
          , 'HTTP Response Splitting', 'Information Leakage', 'Insecure Indexing', 'Insufficient Authentication', 'Insufficient Authorization', 'Insufficient Session Expiration', 'Integer Overflows'
          , 'Null Byte injection', 'OS Commanding', 'Path Traversal', 'Predictable Resource Location', 'Remote File Inclusion', 'Session Fixation', 'SQL Injection', 'URL Redirector Abuse', 'XML External Entities'],
      },
      '3': {
        title: '上線版',
        description: '安裝HTTP伺服器，具有網域與憑證的網站',
        example: 'https://va.nycu.edu.tw',
        testItems: ['Abuse of Functionality', 'Broken Object Level on API', 'Buffer Overflow', 'Content Spoofing', 'Credential/Session Prediction', 'Cross-site Scripting', 'Directory Indexing',
          'Format String', 'HTTP Response Splitting', 'Information Leakage', 'Insecure Indexing', 'Insufficient Authentication', 'Insufficient Session Expiration', 'Insufficient Transport Layer Protection'
          , 'Integer Overflows', ' Null Byte injection', 'OS Commanding', 'Path Traversal', 'Predictable Resource Location', 'Remote File Inclusion', 'Server Misconfiguration', 'Session Fixation'
          , 'SSL Injection', 'URL Redirector Abuse', 'XML External Entities'],
      },
    };

    const { betaversion, showDetails } = this.state;
    return (
      <div className="version-cards__container">
        {Object.keys(versionDetails).map((version) => {
          const details = versionDetails[version];
          const isDetailsVisible = showDetails[version];
          return (
            <div
              key={version}
              className={`version-cards__card ${betaversion === version ? 'version-cards__card--selected' : ''}`}
              onClick={() => this.handleVersionChange(version)}
            >
              <div className="version-cards__header">{details.title}</div>
              <div className="version-cards__description"><p>適用對象:<br />{details.description}</p></div>
              <p>範例網站: <a href={details.example} target="_blank" rel="noopener noreferrer">{details.example}</a></p>
              <button
                className="version-cards__toggle"
                onClick={(e) => {
                  e.stopPropagation(); // 防止card的點擊事件被觸發
                  e.preventDefault();
                  this.toggleDetails(version);
                }}
              >
                {isDetailsVisible ? '隱藏掃描項目資訊' : '顯示掃描項目資訊'}
              </button>
              <div className={`version-cards__body ${isDetailsVisible ? 'version-cards__body--show' : ''}`}>
                <ul>
                  {details.testItems.map((item, index) => <li key={index}>{item}</li>)}
                </ul>
              </div>
            </div>
          );
        })}
      </div>
    );
  };


  // 需要登入的checkbox
  handleCheckboxChange = (event) => {
    this.setState({ requiresLoginScan: event.target.checked });
  }

  // 處理丟文件的檔案
  handleFileChange = (event) => {
    this.setState({ selectedFile: event.target.files[0] });
  }
  // 處理表單選項變更事件
  handleOptionChange = (event) => {
    const { name, value, selectedName } = event.target;
    console.log(value)

    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: value || '',
        Url_name: selectedName || ''
      },
    }));
  };

  // 處理單位選擇變更事件
  handleUnitSelectChange = (data) => {
    const { value, selectedName } = data;

    this.setState(prevState => ({
      selectedUnit: value,
      local_unit_name: selectedName,
      // 清空網站名稱相關的狀態
      selectedUrl: '',
      local_url_name: '',
      formData: {
        ...prevState.formData,
        excel_unit_url: '',  // 清空網站名稱
        Url_name: ''  // 清空網站名稱
      }
    }), () => {
      // console.log("Selected unit updated:", this.state.selectedUnit, this.state.local_unit_name);
    });
  };

  //以下的資料是代理模式使用
  // 處理網域選擇
  handleNetSelectChange = (data) => {
    const { value, selectedName } = data;
    this.setState({
      selectnet: value,
      local_net_name: selectedName,
      // 清空單位名稱和網站名稱相關的狀態
      selectedUnit: '',
      local_unit_name: '',
      selectedUnitproxy: '',
      local_unit_proxy_name: '',
      formData: {
        ...this.state.formData,
        excel_unit_url: '',  // 清空網站名稱
        Url_name: ''  // 清空網站名稱
      }
    }, () => {
      // console.log("Selected net updated:", this.state.selectnet, this.state.local_net_name);
    });
  };

  // 處理人員選擇
  handleUserSelectChange = (data) => {
    const { value, selectedName } = data;
    this.setState({ selecteduser: value, local_user_name: selectedName }, () => {
      // console.log("Selected net updated:", this.state.selecteduser, this.state.local_user_name);
    });
  };
  SelectUnitproxyApply = (data) => {
    const { value, selectedName } = data;
    this.setState({ selectedUnitproxy: value, local_unit_proxy_name: selectedName }, () => {
      // console.log("Selected unit updated:", this.state.selectedUnitproxy, this.state.local_unit_proxy_name);
    });
  };
  handleProxyUrlChange = (event) => {
    const { name, value, selectedName } = event.target;
    this.setState((prevState) => {
      const updatedFormData = {
        ...prevState.formData,
        [name]: value,
        Url_name: selectedName,
      };
      return {
        formData: updatedFormData,
      };
    }, () => {
      // 查看更新後的整個狀態
      // console.log("Updated State:", this.state);
    });
  };



  handleDownload = async () => {
    const fileName = '登入網頁掃描檔案錄製教學.docx';
    const fileUrl = `${api_url}/${fileName}`;

    const response = await fetch(fileUrl);
    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  render() {
    const userType = localStorage.getItem('login_user_type');
    const net_name = localStorage.getItem('login_user_net_name');
    const { betaversion } = this.state;
    let FormDataUsertype;

    if (userType === 'S') {
      if (this.state.checked === false) {
        FormDataUsertype = (
          <Form>
            <FormGroup row inline>
              <Label for="local_net_id" sm={2}>區網名稱</Label>
              <Col sm={10}>
                <SelectNet
                  parentName={'superS'}
                  id={'excel_net_name'}
                  name={'excel_net_name'}
                  requiredAPI={'/api/JRCC/GetLocalNetId'}
                  handleNetSelectChange={this.handleNetSelectChange}
                />
              </Col>
            </FormGroup>
            <FormGroup row inline>
              <Label for="excel_unit_proxy_name" sm={2}>單位名稱</Label>
              <Col sm={10}>
                <SelectUnit
                  parentName={'superS'}
                  id={'excel_unit_proxy_name'}
                  name={'excel_unit_proxy_name'}
                  requiredAPI={'/api/Async/GetNetDownUnitlist'}
                  onUnitSelectChange={this.handleUnitSelectChange}
                  selectnet={this.state.selectnet}
                  local_net_name={this.state.local_net_name}
                />
              </Col>
            </FormGroup>
            <FormGroup row inline>
              <Label for="excel_unit_url" sm={2}>網站名稱</Label>
              <Col sm={10}>
                <SelectUrl
                  parentName={'url'}
                  id={'excel_unit_url'}
                  name={'excel_unit_url'}
                  requiredAPI={'/api/JRCC/GetLocalUrlId'}
                  selectedUnit={this.state.selectedUnit}
                  local_unit_name={this.state.local_unit_name}
                  onChange={this.handleOptionChange} />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="requiresLoginScan" sm={2}>登入網頁掃描</Label>
              <Col sm={10} className="d-flex align-items-center">
                <FormGroup check inline className="mb-0">
                  <Label >
                    <Input
                      type="checkbox"
                      id="requiresLoginScan"
                      checked={this.state.requiresLoginScan}
                      onChange={this.handleCheckboxChange}
                    />{' '}
                    需要
                  </Label>
                </FormGroup>
                {this.state.requiresLoginScan && (
                  <>
                    <input
                      type="file"
                      id="fileUpload"
                      onChange={this.handleFileChange}
                      className="ml-2 custom-file-input"
                    />
                    <div onClick={this.handleDownload} style={{ fontSize: '16px', cursor: 'pointer' }}>
                      <FontAwesomeIcon icon={faFileAlt} /> 登入網頁掃描檔案錄製教學
                    </div>
                  </>
                )}
              </Col>
            </FormGroup>
            {/* 測試資訊詳情 */}
            <div className="version-cards">
              <FormGroup tag="fieldset">
                <Label for="version-betaversion" sm={2}>選擇版本</Label>
                {this.renderTestDetails()}
              </FormGroup>
            </div>
            <FormGroup row>
              <Button
                type="submit"
                className="btn btn-primary col-md-2 col-lg-1 mx-1 my-2"
                onClick={this.handleSubmit}
                disabled={this.state.availableToApplyCount === 0}>
                申請
              </Button>
            </FormGroup>
          </Form>
        );
      }
      else {
        FormDataUsertype = (<Form>
          <FormGroup row inline>
            <Label for="local_net_id" sm={2}>區網名稱</Label>
            <Col sm={10}>
              <SelectNet
                parentName={'superS'}
                id={'excel_net_name'}
                name={'excel_net_name'}
                requiredAPI={'/api/JRCC/GetLocalNetId'}
                handleNetSelectChange={this.handleNetSelectChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="excel_unit_proxy_name" sm={2}>單位名稱</Label>
            <Col sm={10}>
              <SelectUnitproxyApply
                parentName={'superS'}
                id={'excel_unit_proxy_name'}
                name={'excel_unit_proxy_name'}
                requiredAPI={'/api/Async/GetNetDownUnitlist'}
                SelectUnitproxyApply={this.SelectUnitproxyApply}
                selectnet={this.state.selectnet}
                local_net_name={this.state.local_net_name}
              />
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="local_user_id" sm={2}>人員資料</Label>
            <Col sm={10}>
              <SelectName
                parentName={'superS'}
                id={'excel_user_name'}
                name={'excel_user_name'}
                requiredAPI={'/api/Async/GetUserdatalist'}
                handleUserSelectChange={this.handleUserSelectChange}
                selectedUnitproxy={this.state.selectedUnitproxy}
                local_unit_proxy_name={this.state.local_unit_proxy_name}
                selectnet={this.state.selectnet}
                local_net_name={this.state.local_net_name}
              />
            </Col>
          </FormGroup>
          <FormGroup row inline>
            <Label for="excel_unit_proxy_url" sm={2}>網站名稱</Label>
            <Col sm={10}>
              <SelectUrlProxyApply
                parentName={'superS'}
                id={'excel_unit_proxy_url'}
                name={'excel_unit_proxy_url'}
                requiredAPI={'/api/Async/GetUserUrllist'}
                selectnet={this.state.selectnet}
                local_net_name={this.state.local_net_name}
                selectedUnitproxy={this.state.selectedUnitproxy}
                local_unit_proxy_name={this.state.local_unit_proxy_name}
                selecteduser={this.state.selecteduser}
                onChange={this.handleProxyUrlChange} />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="requiresLoginScan" sm={2}>登入網頁掃描</Label>
            <Col sm={10} className="d-flex align-items-center">
              <FormGroup check inline className="mb-0">
                <Label >
                  <Input
                    type="checkbox"
                    id="requiresLoginScan"
                    checked={this.state.requiresLoginScan}
                    onChange={this.handleCheckboxChange}
                  />{' '}
                  需要
                </Label>
              </FormGroup>
              {this.state.requiresLoginScan && (
                <>
                  <input
                    type="file"
                    id="fileUpload"
                    onChange={this.handleFileChange}
                    className="ml-2 custom-file-input"
                  />
                  <div onClick={this.handleDownload} style={{ fontSize: '16px', cursor: 'pointer' }}>
                    <FontAwesomeIcon icon={faFileAlt} /> 登入網頁掃描檔案錄製教學
                  </div>
                </>
              )}
            </Col>
          </FormGroup>
          {/* 測試資訊詳情 */}
          <div className="version-cards">
            <FormGroup tag="fieldset">
              <Label for="version-betaversion" sm={2}>選擇版本</Label>
              {this.renderTestDetails()}
            </FormGroup>
          </div>
          <Button
            type="submit"
            className="btn btn-primary col-md-2 col-lg-1 mx-1 my-2"
            onClick={this.handleProxySubmit}
            disabled={this.state.availableToApplyCount === 0}>
            申請
          </Button>
        </Form>
        );
      }
    }
    else if (userType === 'M') {
      if (this.state.checked === false) {
        FormDataUsertype =
          (<Form>
            <FormGroup row inline>
              <Label sm={2}>區網名稱</Label>
              <Col sm={10}>
                <span className="form-control-plaintext">{net_name}</span>
              </Col>
            </FormGroup>
            <FormGroup row inline>
              <Label for="excel_unit_name" sm={2}>單位名稱</Label>
              <Col sm={10}>
                <SelectUnit
                  parentName={'Excel'}
                  id={'excel_unit_name'}
                  name={'excel_unit_name'}
                  requiredAPI={'/api/JRCC/GetLocalUnitId'}
                  onUnitSelectChange={this.handleUnitSelectChange}
                />
              </Col>
            </FormGroup>
            <FormGroup row inline>
              <Label for="excel_unit_url" sm={2}>網站名稱</Label>
              <Col sm={10}>
                <SelectUrl
                  parentName={'url'}
                  id={'excel_unit_url'}
                  name={'excel_unit_url'}
                  requiredAPI={'/api/JRCC/GetLocalUrlId'}
                  selectedUnit={this.state.selectedUnit}
                  local_unit_name={this.state.local_unit_name}
                  onChange={this.handleOptionChange} />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="requiresLoginScan" sm={2}>登入網頁掃描</Label>
              <Col sm={10} className="d-flex align-items-center">
                <FormGroup check inline className="mb-0">
                  <Label >
                    <Input
                      type="checkbox"
                      id="requiresLoginScan"
                      checked={this.state.requiresLoginScan}
                      onChange={this.handleCheckboxChange}
                    />{' '}
                    需要
                  </Label>
                </FormGroup>
                {this.state.requiresLoginScan && (
                  <>
                    <input
                      type="file"
                      id="fileUpload"
                      onChange={this.handleFileChange}
                      className="ml-2 custom-file-input"
                    />
                    <div onClick={this.handleDownload} style={{ fontSize: '16px', cursor: 'pointer' }}>
                      <FontAwesomeIcon icon={faFileAlt} /> 登入網頁掃描檔案錄製教學
                    </div>
                  </>
                )}
              </Col>
            </FormGroup>
            {/* 測試資訊詳情 */}
            <div className="version-cards">
              <FormGroup tag="fieldset">
                <Label for="version-betaversion" sm={2}>選擇版本</Label>
                {this.renderTestDetails()}
              </FormGroup>
            </div>
            <Button
              type="submit"
              className="btn btn-primary col-md-2 col-lg-1 mx-1 my-2"
              onClick={this.handleSubmit}
              disabled={this.state.availableToApplyCount === 0}>
              申請
            </Button>
          </Form>
          )
      } else {
        FormDataUsertype =
          (<Form>
            <FormGroup row inline>
              <Label sm={2}>區網名稱</Label>
              <Col sm={10}>
                <span className="form-control-plaintext">{net_name}</span>
              </Col>
            </FormGroup>
            <FormGroup row inline>
              <Label for="excel_unit_proxy_name" sm={2}>單位名稱</Label>
              <Col sm={10}>
                <SelectUnitproxyApply
                  parentName={'superM'}
                  id={'excel_unit_proxy_name'}
                  name={'excel_unit_proxy_name'}
                  requiredAPI={'/api/Async/GetNetDownUnitlist'}
                  SelectUnitproxyApply={this.SelectUnitproxyApply}
                  selectnet={this.state.fetchDataForTableProxyApply.local_net_id}
                  local_net_name={net_name}
                />
              </Col>
            </FormGroup>
            <FormGroup row inline>
              <Label for="local_user_id" sm={2}>人員資料</Label>
              <Col sm={10}>
                <SelectName
                  parentName={'superM'}
                  id={'excel_user_name'}
                  name={'excel_user_name'}
                  requiredAPI={'/api/Async/GetUserdatalist'}
                  handleUserSelectChange={this.handleUserSelectChange}
                  selectedUnitproxy={this.state.selectedUnitproxy}
                  local_unit_proxy_name={this.state.local_unit_proxy_name}
                  selectnet={this.state.fetchDataForTableApply.local_net_id}
                  local_net_name={net_name}
                />
              </Col>
            </FormGroup>
            <FormGroup row inline>
              <Label for="excel_unit_proxy_url" sm={2}>網站名稱</Label>
              <Col sm={10}>
                <SelectUrlProxyApply
                  parentName={'superM'}
                  id={'excel_unit_proxy_url'}
                  name={'excel_unit_proxy_url'}
                  requiredAPI={'/api/Async/GetUserUrllist'}
                  selectnet={this.state.fetchDataForTableApply.local_net_id}
                  local_net_name={net_name}
                  selectedUnitproxy={this.state.selectedUnitproxy}
                  local_unit_proxy_name={this.state.local_unit_proxy_name}
                  selecteduser={this.state.selecteduser}
                  onChange={this.handleProxyUrlChange} />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="requiresLoginScan" sm={2}>登入網頁掃描</Label>
              <Col sm={10} className="d-flex align-items-center">
                <FormGroup check inline className="mb-0">
                  <Label >
                    <Input
                      type="checkbox"
                      id="requiresLoginScan"
                      checked={this.state.requiresLoginScan}
                      onChange={this.handleCheckboxChange}
                    />{' '}
                    需要
                  </Label>
                </FormGroup>
                {this.state.requiresLoginScan && (
                  <>
                    <input
                      type="file"
                      id="fileUpload"
                      onChange={this.handleFileChange}
                      className="ml-2 custom-file-input"
                    />
                    <div onClick={this.handleDownload} style={{ fontSize: '16px', cursor: 'pointer' }}>
                      <FontAwesomeIcon icon={faFileAlt} /> 登入網頁掃描檔案錄製教學
                    </div>
                  </>
                )}
              </Col>
            </FormGroup>
            {/* 測試資訊詳情 */}
            <div className="version-cards">
              <FormGroup tag="fieldset">
                <Label for="version-betaversion" sm={2}>選擇版本</Label>
                {this.renderTestDetails()}
              </FormGroup>
            </div>
            <Button
              type="submit"
              className="btn btn-primary col-md-2 col-lg-1 mx-1 my-2"
              onClick={this.handleProxySubmit}
              disabled={this.state.availableToApplyCount === 0}>
              申請
            </Button>
          </Form>
          )
      }
    }
    else if (userType === 'N') {
      FormDataUsertype = (<Form>
        <FormGroup row inline>
          <Label for="excel_unit_name" sm={2}>單位名稱</Label>
          <Col sm={10}>
            <span className="form-control-plaintext">{this.state.firstLocalUnitName}</span>
          </Col>
        </FormGroup>

        <FormGroup row inline>
          <Label for="excel_unit_url" sm={2}>網站名稱</Label>
          <Col sm={10}>
            <SelectUrl
              parentName={'url'}
              id={'excel_unit_url'}
              name={'excel_unit_url'}
              requiredAPI={'/api/JRCC/GetLocalUrlId'}
              selectedUnit={this.state.firstLocalUnitValue}
              local_unit_name={this.state.firstLocalUnitName}
              onChange={this.handleOptionChange} />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="requiresLoginScan" sm={2}>登入網頁掃描</Label>
          <Col sm={10} className="d-flex align-items-center">
            <FormGroup check inline className="mb-0">
              <Label >
                <Input
                  type="checkbox"
                  id="requiresLoginScan"
                  checked={this.state.requiresLoginScan}
                  onChange={this.handleCheckboxChange}
                />{' '}
                需要
              </Label>
            </FormGroup>
            {this.state.requiresLoginScan && (
              <>
                <input
                  type="file"
                  id="fileUpload"
                  onChange={this.handleFileChange}
                  className="ml-2 custom-file-input"
                />
                <div onClick={this.handleDownload} style={{ fontSize: '16px', cursor: 'pointer' }}>
                  <FontAwesomeIcon icon={faFileAlt} /> 登入網頁掃描檔案錄製教學
                </div>
              </>
            )}
          </Col>
        </FormGroup>
        {/* 測試資訊詳情 */}
        <div className="version-cards">
          <FormGroup tag="fieldset">
            <Label for="version-betaversion" sm={2}>選擇版本</Label>
            {this.renderTestDetails()}
          </FormGroup>
        </div>
        <Button
          type="submit"
          className="btn btn-primary col-md-2 col-lg-1 mx-1 my-2"
          onClick={this.handleSubmit}
          disabled={this.state.availableToApplyCount === 0}>
          申請
        </Button>
      </Form>
      )
    }

    return (
      <div>
        <div className="mt-5">
          <h1 id="tableLabel" className='mb-3'>檢測網站申請</h1>
          {(userType === 'S' || userType === 'M') && (
            <button
              className={this.state.checked ? "button-switch on" : "button-switch off"}
              onClick={this.handleChange}>
              {this.state.checked ? "代理模式" : "掃描模式"}
            </button>
          )}

          <div id="site_manage" className="row col-12 mb-5 justify-content-center">
            <div className="row justify-content-center">
              <div className="row col-sm-12 col-md-10 col-lg-8 rounded-3 d-inline-flex justify-content-start skin-white">
                <h6 className="col-auto pt-2">個人同時最多可申請網站數: <span className="badge gray-green">8</span></h6>
                <h6 className="col-auto pt-2">個人目前同時已經申請網站數: <span className="badge gray-green">{this.state.pendingInspectionCount}</span></h6>
                <h6 className="col-auto pt-2">個人目前同時可申請網站數: <span className="badge gray-green">{this.state.availableToApplyCount}</span></h6>
                {/* <h6 className="col-auto pt-2">個人目前申請等待最快執行順位: <span className="badge gray-green">{this.state.waitingQueuePosition}</span></h6> */}
                {(userType === 'S') && (
                  <h6 className="col-auto pt-2">目前系統已申請網站數: <span className="badge gray-green">{this.state.allusagecountToCount}</span></h6>)}
              </div>
            </div>
            <div className="row col-sm-12 col-md-10 col-lg-8 rounded-3 d-inline-flex justify-content-center align-content-center mt-4">
              {FormDataUsertype}
            </div>
          </div>

          {this.state.isFetchDataApply && (
            <>
              {(userType === 'S' && this.state.checked === true) && (
                <FetchDataApplyNet
                  fetchDataForTableProxyApply={this.state.fetchDataForTableProxyApply}
                  selectnet={this.state.selectnet}
                  local_net_name={this.state.local_net_name}
                  selectedUnitproxy={this.state.selectedUnitproxy}
                  selecteduser={this.state.selecteduser}
                  local_user_name={this.state.local_user_name}
                  onPendingInspectionItemsChange={this.handlePendingInspectionItemsChange}
                  isFetchDataApply={this.state.isFetchDataApply}
                  submitCount={this.state.submitCount}
                  resetSubmitCount={this.resetSubmitCount}
                />
              )}
              {(userType === 'M' && this.state.checked === true) && (
                <FetchDataApplyNet
                  fetchDataForTableProxyApply={this.state.fetchDataForTableProxyApply}
                  selectnet={this.state.fetchDataForTableProxyApply.local_net_id}
                  local_net_name={net_name}
                  selectedUnitproxy={this.state.selectedUnitproxy}
                  selecteduser={this.state.selecteduser}
                  local_user_name={this.state.local_user_name}
                  onPendingInspectionItemsChange={this.handlePendingInspectionItemsChange}
                  isFetchDataApply={this.state.isFetchDataApply}
                  submitCount={this.state.submitCount}
                  resetSubmitCount={this.resetSubmitCount}
                />
              )}
              {((userType === 'M' || userType === 'N' || userType === 'S') && this.state.checked === false) && (
                <FetchDataApply
                  fetchDataForTableApply={this.state.fetchDataForTableApply}
                  onPendingInspectionItemsChange={this.handlePendingInspectionItemsChange}
                />
              )}
            </>
          )}

        </div>
      </div>
    )
  }
}